export const baseUrl = 'https://sanjaverse.pythonanywhere.com/api/v1'